import ioTypes from '@/constants/order/ioTypes';
const values = {
  wagon: {
    basedata: {
      chapters: {
        basedata: {
          data: [
            {
              path: 'WagonNumber',
              type: 'string',
              ignoreProgress: true,
            },
            {
              path: 'VehicleKeeperMarking',
              type: 'option',
              option: 'ListingOwnersMark',
              showTranslatedText: false,
            },
            {
              path: 'EntryDate',
              type: 'date',
              ioType: ioTypes.INCOMING,
              halfWidth: true,
              activityType: 'ACTIVITY',
            },
            {
              path: 'ExitDate',
              type: 'date',
              ioType: ioTypes.OUTGOING,
              halfWidth: true,
              activityType: 'ACTIVITY',
            },
            {
              path: 'OverhaulDate',
              type: 'date',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'PerformedMaintenanceLevel',
              type: 'option',
              option: 'ListingMaintenanceLevelPerformed',
              showTranslatedText: true,
            },
            {
              path: 'RevisionType',
              type: 'option',
              option: 'ListingMaintenanceLevelPerformed',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'TareWeight',
              type: 'double',
              unit: 'kg',
            },
            {
              path: 'NumberOfSubsetVehicles',
              type: 'option',
              option: 'ListingNumberOfSubsetVehicles',
              inputType: 'double',
            },
            {
              path: 'NumberOfAxles',
              type: 'option',
              option: 'ListingNumberOfAxles',
              inputType: 'double',
            },
            {
              path: 'NumberOfBogies',
              type: 'option',
              option: 'ListingNumberOfBogies',
              inputType: 'double',
            },
            {
              path: 'LastGood',
              type: 'string',
            },
            {
              path: 'AxleLoadLimit',
              type: 'option',
              option: 'ListingMaximumWheelsetLoad',
              inputType: 'double',
              unit: 't',
            },
            /*{
                                path: 'Chassis.BogieCollection.Bogie[0].SuspensionSpringCollection.SuspensionSpring[0].VPICodeNumber',
                                name: 'SchluesselzifferVPI',
                                type: 'option',
                                option: 'ListingSuspensionSpringVPICodeNumber',
                                showTranslatedText: true
                            },*/
            {
              path: 'TemperatureRangeAccordingToTSI',
              type: 'option',
              option: 'ListingTemperatureRangeAccordingToTSI',
            },
            {
              path: 'TSIApproval',
              type: 'boolean',
            },
            {
              path: 'TSINoBo',
              name: 'TSIZulassungsstelle',
              type: 'option',
              option: 'ListingTSINotifiedBody',
              showTranslatedText: true,
            },
          ],
        },
        baseBogies: {
          uniformPaths: [
            'SuspensionSpringCollection.SuspensionSpring[0].VPICodeNumber',
            'SpringSuspensionType',
            'Wheelbase',
          ],
          listPath: 'Chassis.BogieCollection.Bogie',
          differentiator: 'Position',
          differentiatorOption: 'ListingBogiePosition',
          differentiatorName: 'Position',
          currentUniform: true,
          data: [
            {
              path: 'SuspensionSpringCollection.SuspensionSpring[0].VPICodeNumber',
              name: 'SchluesselzifferVPI',
              type: 'option',
              option: 'ListingSuspensionSpringVPICodeNumber',
              showTranslatedText: true,
            },
            {
              path: 'SpringSuspensionType',
              name: 'ArtdesFedergehaenges',
              type: 'option',
              option: 'ListingSuspensionSpringType',
            },
            {
              path: 'Wheelbase',
              type: 'double',
              option: 'ListingBogieWheelbase',
              unit: 'm',
            },
          ],
        },
        bogies: {
          differentiator: 'Position',
          differentiatorOption: 'ListingBogiePosition',
          differentiatorName: 'Position',
          uniformPaths: [
            'SuspensionSpringCollection.SuspensionSpring[0].VPICodeNumber',
          ],
          dependentPaths: [
            {
              quantity: 3,
              path: 'NumberOfSubsetVehicles',
              option: 'ListingNumberOfSubsetVehicles',
              upperValue: 2,
              lowerValue: 1,
            },
          ],
          data: [
            {
              path: 'Position',
              name: 'Position',
              type: 'option',
              option: 'ListingBogiePosition',
              inputType: 'double',
            },
            {
              path: 'productIdentifier',
              type: 'baseString',
            },
            {
              path: 'DBType',
              name: 'BogieDbseriesNumber',
              type: 'option',
              option: 'ListingBogieType',
            },
            {
              path: 'Type',
              name: 'BogieType',
              type: 'option',
              option: 'ListingBogieClassType',
              showTranslatedText: true,
            },
            {
              path: 'SuspensionSpringCollection.SuspensionSpring[0].VPICodeNumber',
              name: 'SchluesselzifferVPI',
              type: 'option',
              option: 'ListingSuspensionSpringVPICodeNumber',
              showTranslatedText: true,
            },
            {
              path: 'SpringSuspensionType',
              name: 'ArtdesFedergehaenges',
              type: 'option',
              option: 'ListingSuspensionSpringType',
            },
            {
              path: 'Specification',
              type: 'option',
              option: 'ListingBogieSpecification',
            },
            {
              path: 'LargestDimensionz8',
              type: 'double',
              unit: 'mm',
            },
            {
              path: 'SmallestDimensionz8',
              type: 'double',
              unit: 'mm',
            },
            {
              path: 'NominalDimensionz8',
              type: 'double',
              unit: 'mm',
            },
            {
              path: 'Wheelbase',
              type: 'double',
              option: 'ListingBogieWheelbase',
              unit: 'm',
            },
          ],
          listPath: 'Chassis.BogieCollection.Bogie',
        },
        additional: {
          data: [
            {
              path: 'DeferredWork',
              type: 'textarea',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'FurtherInformationReleaseToService',
              ioType: ioTypes.OUTGOING,
              type: 'textarea',
            },
          ],
        },
      },
    },
    labeling: {
      data: [
        {
          path: 'LooseAndFlyShuntingProhibited',
          type: 'boolean',
        },
        {
          path: 'FlyShuntingProhibition',
          type: 'boolean',
        },
        {
          path: 'ReplacementProcedure',
          type: 'option',
          option: 'ListingReplacementProcedure',
        },
        {
          path: 'DemarcationProfile',
          type: 'option',
          option: 'ListingDemarcationProfile',
        },
        {
          path: 'CurveRadius',
          type: 'option',
          option: 'Bogenhalbmesser',
          inputType: 'double',
          unit: 'm',
        },
        {
          path: 'DistanceBetweenBogiePivots',
          type: 'double',
          unit: 'm',
        },
        {
          path: 'FerryboatCapability',
          type: 'boolean',
        },
        {
          path: 'RampAngle230',
          type: 'boolean',
        },
        {
          path: 'MarshallingHumpCrestRadius',
          type: 'option',
          option: 'Kuppenradius',
          inputType: 'double',
          unit: 'm',
        },
        {
          path: 'LengthOverBuffers',
          type: 'double',
          unit: 'm',
        },
        {
          path: 'TreadDiameterMax',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'TunnelCapability',
          type: 'boolean',
        },
        {
          path: 'UICClass',
          type: 'option',
          option: 'ListingWagonUicClass',
        },
        {
          path: 'Chassis.UnderframeCollection.Underframe[0].TorsionallyStiff',
          name: 'TorsionallyStiff',
          type: 'boolean',
        },
        {
          path: 'Chassis.Brake.HandBrakeBrakeload',
          type: 'double',
          unit: 't',
        },
        {
          path: 'Chassis.Brake.MaxDecline',
          type: 'double',
          unit: '%',
        },
        {
          path: 'Inscriptions.ThirdPartyAdvertising',
          type: 'boolean',
        },
      ],
    },
    revisionDeadline: {
      data: [
        {
          path: 'WorkshopLastG40',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLastG40',
          type: 'date',
        },
        {
          path: 'WorkshopLastG42',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLastG42',
          type: 'date',
        },
        {
          path: 'WorkshopLastG43',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLastG43',
          type: 'date',
        },
        {
          path: 'WorkshopLastG48',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLastG48',
          type: 'date',
        },
        {
          path: 'WorkshopLastG481',
          type: 'option',
          option: 'ListingWorkshop',
        },
        {
          path: 'DateLastG481',
          type: 'date',
        },
        {
          path: 'WorkshopLastG482',
          type: 'option',
          option: 'ListingWorkshop',
        },
        {
          path: 'DateLastG482',
          type: 'date',
        },
        {
          path: 'WorkshopLastG483',
          type: 'option',
          option: 'ListingWorkshop',
        },
        {
          path: 'DateLastG483',
          type: 'date',
        },
        {
          path: 'RevisionCycle',
          type: 'option',
          option: 'ListingMaintenanceCycle',
          inputType: 'double',
          unit: 'y',
        },
        {
          path: 'PeriodicMaintenanceCycle',
          type: 'option',
          option: 'ListingRevisionCycle',
          inputType: 'double',
          unit: 'M',
        },
        {
          path: 'RevisionPeriodExtension',
          type: 'option',
          option: 'ListingRevisionPeriodExtension',
          inputType: 'double',
          unit: 'M',
        },
        {
          path: 'DateLastPleriodicMaintenance',
          type: 'date',
        },
        {
          path: 'componentPeriodsA',
          type: 'string',
          ioType: ioTypes.OUTGOING,
          activityType: 'ACTIVITY',
        },
        {
          path: 'componentCycleA',
          type: 'string',
          ioType: ioTypes.OUTGOING,
          activityType: 'ACTIVITY',
        },
        {
          path: 'componentPeriodsB',
          type: 'string',
          ioType: ioTypes.OUTGOING,
          activityType: 'ACTIVITY',
        },
        {
          path: 'componentCycleB',
          type: 'string',
          ioType: ioTypes.OUTGOING,
          activityType: 'ACTIVITY',
        },
      ],
    },
    loadLimitGrid: {
      chapters: {
        base: {
          data: [
            {
              path: 'Inscriptions.TypeOfGoodsInscription',
              type: 'option',
              option: 'ListingGoodsInscriptionType',
              callbackMutation: 'order/setCurrentLoadLimitGridType',
              showTranslatedText: true,
            },
            {
              path: 'Inscriptions.NoHazardousGoodsRID',
              type: 'boolean',
            },
            {
              path: 'Is120kmhCapable',
              type: 'boolean',
            },
          ],
        },
        loadLimitGrid: {
          differentiator: 'FoldingPanelNumber',
          differentiatorOption: 'ListingFoldingPanel',
          listPath: 'Inscriptions.FoldingPanelsCollection.FoldingPanels',
          uniformPaths: ['LoadLimitPanel.Type'],
          chapters: {
            loadLimitGrid: {
              data: [
                {
                  path: 'LoadLimitPanel.Type',
                  type: 'option',
                  option: 'ListingLoadLimitPanelType',
                  showTranslatedText: true,
                  callbackMutation: 'order/updateLoadLimitType',
                },
                {
                  path: 'FoldingPanelNumber',
                  type: 'option',
                  option: 'ListingFoldingPanel',
                  inputType: 'double',
                },
                {
                  name: 'Anschriften.Ladegut',
                  path: 'LoadableGoods',
                  type: 'option',
                  option: 'ListingLoadedGood',
                  showTranslatedText: true,
                },
                {
                  path: 'LoadLimitPanel.A100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.A120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.B100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.B120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.B1100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.B1120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.B2100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.B2120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.C100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.C120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.C2100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.C2120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.C3100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.C3120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.C4100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.C4120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.D100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.D120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.D2100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.D2120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.D3100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.D3120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.D4100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.D4120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.E100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.E4100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.E4120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.E5100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.E5120',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'LoadLimitPanel.Stars',
                  type: 'option',
                  option: 'ListingLoadLimitPanelStars',
                  showTranslatedText: true,
                },
              ],
            },
            additionalGrid: {
              listPath: 'SupplementaryPanelCollection.SupplementaryPanel',
              differentiator: 'SerialNoOfCountriesGroup',
              differentiatorOption: 'ListingSerialNumberOfCountriesGroup',
              differentiatorName: 'Position',
              data: [
                {
                  path: 'SerialNoOfCountriesGroup',
                  type: 'option',
                  option: 'ListingSerialNumberOfCountriesGroup',
                  inputType: 'double',
                },
                {
                  path: 'CountriesGroup',
                  type: 'multioption',
                  option: 'ListingCountryCode',
                  showTranslatedText: true,
                },
                {
                  path: 'CMD80',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'CMD100',
                  type: 'double',
                  unit: 't',
                },
                {
                  path: 'CM100',
                  type: 'double',
                  unit: 't',
                },
              ],
            },
          },
        },
      },
    },
    aggreementGrid: {
      data: [
        {
          path: 'Inscriptions.DerogationPanel.CountriesGroup',
          type: 'multioption',
          option: 'ListingCountryCode',
          showTranslatedText: true,
        },
        {
          path: 'Inscriptions.DerogationPanel.CountryOfOrigin',
          type: 'option',
          option: 'ListingCountryCode',
          showTranslatedText: true,
        },
      ],
    },
    brake: {
      chapters: {
        brake: {
          data: [
            {
              path: 'Chassis.Brake.BrakeRevisionType',
              type: 'option',
              option: 'ListingBrakeRevisionType',
              showTranslatedText: true,
            },
            {
              path: 'Chassis.Brake.BrakeRevisionDate',
              type: 'date',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'Chassis.Brake.Type',
              type: 'option',
              option: 'ListingBrakeType',
              showTranslatedText: true,
            },
            {
              path: 'Chassis.Brake.ChangeoverWeight',
              type: 'double',
              unit: 't',
            },
            {
              path: 'Chassis.Brake.BrakedWeightEmpty',
              type: 'double',
              unit: 't',
            },
            {
              path: 'Chassis.Brake.BrakedWeightLoaded',
              type: 'double',
              unit: 't',
            },
            {
              path: 'Chassis.Brake.MaximalBrakeLoad',
              type: 'double',
              unit: 't',
            },
            {
              path: 'Chassis.Brake.LoadProportionalBraking',
              type: 'option',
              option: 'ListingLoadProportionalBraking',
            },
            {
              path: 'Chassis.Brake.DiskBrake',
              type: 'boolean',
            },
            {
              path: 'Chassis.Brake.TypeUIC5431',
              type: 'option',
              option: 'ListingBreakTestingUICLeafletType',
            },
          ],
        },
        valve: {
          listPath:
            'Chassis.Brake.PneumaticComponents.DistributorValveCollection.DistributorValve',
          differentiator: 'Position',
          differentiatorOption: 'ListingDistributorValvePosition',
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingDistributorValvePosition',
              inputType: 'double',
            },
            {
              path: 'productIdentifier',
              type: 'baseString',
            },
            {
              path: 'Type',
              name: 'SteuerventilArt',
              type: 'option',
              option: 'ListingDistributorValveType',
              showTranslatedText: true,
            },
            {
              path: 'DateLastRefurbishment',
              name: 'SteuerventilLetzteAufarbeitung',
              type: 'date',
            },
          ],
        },
        airReservoir: {
          listPath:
            'Chassis.Brake.PneumaticComponents.AirReservoirCollection.AirReservoir',
          differentiator: 'Position',
          differentiatorOption: 'ListingAirReservoirPosition',
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingAirReservoirPosition',
              inputType: 'double',
            },
            {
              path: 'YearOfManufacture',
              name: 'LuftbehaelterYearOfManufacture',
              type: 'year',
            },
            {
              path: 'LastInspectionDate',
              name: 'LuftbehaelterLastInspectionDate',
              type: 'date',
            },
            {
              path: 'Volume',
              name: 'LuftbehaelterVolume',
              type: 'option',
              option: 'ListingAirReservoirVolume',
              inputType: 'double',
              unit: 'l',
            },
          ],
        },
        loadValve: {
          listPath:
            'Chassis.Brake.PneumaticComponents.LoadProportionalValveCollection.LoadProportionalValve',
          differentiator: 'PositionLoadProportionalValve',
          differentiatorName: 'Position',
          differentiatorOption: 'ListingPositionLoadProportionalValve',
          data: [
            {
              path: 'PositionLoadProportionalValve',
              type: 'option',
              name: 'Position',
              option: 'ListingPositionLoadProportionalValve',
            },
            {
              path: 'Quantity',
              name: 'WiegeventilQuantity',
              type: 'option',
              option: 'ListingWeighingValveQuantity',
              inputType: 'double',
            },
            {
              path: 'Type',
              name: 'WiegeventilType',
              type: 'option',
              option: 'ListingWeighingValveType',
            },
          ],
        },
        relayValve: {
          data: [
            {
              path: 'Chassis.Brake.PneumaticComponents.RelayValve.Type',
              name: 'RelaisventilType',
              type: 'option',
              option: 'ListingRelayValveType',
            },
          ],
        },
        cylinder: {
          listPath:
            'Chassis.Brake.MechanicalComponents.BrakeCylinderCollection.BrakeCylinder',
          differentiator: 'Position',
          differentiatorOption: 'ListingBrakeCylinderPosition',
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingBrakeCylinderPosition',
              inputType: 'double',
            },
            {
              path: 'productIdentifier',
              type: 'baseString',
            },
            {
              path: 'Type',
              name: 'brakeCylinder',
              type: 'option',
              option: 'ListingBrakeCylinderType',
              showTranslatedText: true,
            },
            {
              path: 'Dimension',
              name: 'brakeCylinderDimension',
              type: 'option',
              option: 'ListingBrakeCylinderDimension',
              unit: 'mm',
            },
            {
              path: 'PistonStrokeLoadedMaxNegTol',
              name: 'brakeCylinderKolbenhubBeladenMaxNegTol',
              type: 'double',
              unit: 'mm',
            },
            {
              path: 'PistonStrokeLoadedMaxPosTol',
              name: 'brakeCylinderKolbenhubBeladenMaxPosTol',
              type: 'double',
              unit: 'mm',
            },
            {
              path: 'PistonStrokeLoadedTarget',
              name: 'brakeCylinderKolbenhubBeladenSoll',
              type: 'double',
              unit: 'mm',
            },
          ],
        },
        rodAdjuster: {
          listPath:
            'Chassis.Brake.MechanicalComponents.SlackAdjusterCollection.SlackAdjuster',
          differentiator: 'Position',
          differentiatorOption: 'ListingBrakeCylinderPosition',
          differentiatorName: 'Position',
          maxSize: 4,
          data: [
            {
              path: 'Position',
              type: 'option',
              name: 'Position',
              option: 'ListingDetailedPosition',
              inputType: 'double',
            },
            {
              path: 'productIdentifier',
              type: 'baseString',
            },
            {
              path: 'Type',
              name: 'rodAdjuster',
              type: 'option',
              option: 'ListingSlackAdjusterType',
              showTranslatedText: true,
            },
            {
              path: 'AdjustmentLength',
              type: 'option',
              option: 'ListingSlackAdjusterAdjustmentLength',
              inputType: 'double',
              unit: 'mm',
            },
          ],
        },
        brakeblockHolder: {
          data: [
            {
              path: 'Chassis.Brake.MechanicalComponents.BrakeBlockHolder.Type',
              name: 'BrakeblockHolderType',
              type: 'option',
              option: 'ListingBrakeBlockShoeType',
            },
          ],
        },
        brakeblockShoe: {
          data: [
            {
              path: 'Chassis.Brake.MechanicalComponents.BrakeBlock.AmountPerWagon',
              name: 'BrakeBlockShoeAnzahlproWagen',
              type: 'double',
            },
            {
              path: 'Chassis.Brake.MechanicalComponents.BrakeBlock.Dimension',
              name: 'BrakeBlockShoeDimension',
              type: 'option',
              option: 'ListingBrakeBlockSize',
              inputType: 'double',
              unit: 'mm',
            },
            {
              path: 'Chassis.Brake.MechanicalComponents.BrakeBlock.BrakeBlockShoeDenomination',
              name: 'BrakeBlockShoeBrakeBlockShoeDenomination',
              type: 'option',
              option: 'ListingBrakeBlockShoeDesignation',
            },
            {
              path: 'Chassis.Brake.MechanicalComponents.BrakeBlock.Material',
              name: 'BrakeBlockShoeMaterial',
              type: 'option',
              option: 'ListingBrakeBlockMaterial',
            },
          ],
        },
        handBrake: {
          listPath: 'Chassis.Brake.HandBrakeCollection.HandBrake',
          differentiator: 'HandBrakePosition',
          differentiatorName: 'Position',
          differentiatorOption: 'ListingHandBrakePosition',
          data: [
            {
              path: 'HandBrakePosition',
              type: 'option',
              name: 'Position',
              option: 'ListingHandBrakePosition',
              inputType: 'double',
            },
            {
              path: 'BrakePlatformCommand',
              name: 'HandbremseBrakePlatformCommand',
              type: 'boolean',
            },
            {
              path: 'OperableFromGroundLevel',
              name: 'HandbremseBottomCommand',
              type: 'boolean',
            },
          ],
        },
        detektor: {
          data: [
            {
              path: 'Chassis.Brake.DerailmentDetector.Manufacturer',
              name: 'Entgleisungsdetektor.Hersteller',
              type: 'option',
              option: 'ListingManufacturer',
            },
            {
              path: 'Chassis.Brake.DerailmentDetector.ManufacturersDesignation',
              name: 'Entgleisungsdetektor.Herstellerbezeichnung',
              type: 'option',
              option: 'ListingDerailmentDetectorManufacturerDesignation',
            },
          ],
        },
      },
    },
    wheelsets: {
      chapters: {
        basedata: {
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingDetailedPosition',
              ignoreProgress: true,
              inputType: 'double',
            },
            {
              path: 'WheelsetNumber',
              type: 'string',
              ignoreProgress: true,
            },
            {
              path: 'DismountDate',
              type: 'date',
              ioType: ioTypes.INCOMING,
              halfWidth: true,
              activityType: 'ACTIVITY',
            },
            {
              path: 'MountDate',
              type: 'date',
              ioType: ioTypes.OUTGOING,
              halfWidth: true,
              activityType: 'ACTIVITY',
            },
            {
              path: 'StampedInstallationDate',
              type: 'monthAndYear',
            },
            {
              path: 'Type',
              name: 'WheelsetType',
              type: 'option',
              option: 'ListingWheelsetType',
              showTranslatedText: true,
            },
            {
              path: 'WheelsetOwnersMark',
              type: 'option',
              option: 'ListingOwnersMark',
              showTranslatedText: true,
            },
            {
              path: 'RemovalReason',
              type: 'option',
              option: 'ListingReasonForWheelsetRemoval',
              showTranslatedText: true,
            },
            {
              path: 'MaintenanceDate',
              name: 'OverhaulDate',
              type: 'date',
            },
            {
              path: 'PerformedISMaintenanceLevel',
              type: 'option',
              option: 'ListingWheelsetPerformedMaintenanceLevel',
              showTranslatedText: true,
            },
            {
              path: 'GeneralBearingHousingType',
              type: 'option',
              option: 'ListingWheelsetBearingHousingType',
              showTranslatedText: true,
            },
            {
              path: 'a1Dimension',
              type: 'double',
              invoke: 'calculateSRMass',
              unit: 'mm',
            },
            {
              path: 'a2Dimension',
              type: 'formula',
              formula: 'calculateSRMass',
              decimalPlaces: 3,
              params: {
                ar: { path: 'a1Dimension' },
                sdA: { path: 'WheelCollection.Wheel[0].FlangeThicknessE' },
                sdB: { path: 'WheelCollection.Wheel[1].FlangeThicknessE' },
              },
            },
          ],
        },
        wheelBasedata: {
          listPath: 'WheelCollection.Wheel',
          differentiator: 'Side',
          differentiatorOption: 'ListingSide',
          fixedSet: true,
          data: [
            {
              path: 'LfNrderSchmelzeRad',
              type: 'string',
            },
            {
              path: 'CastingBatchNumber',
              type: 'string',
            },
          ],
        },
        axleBasedata: {
          data: [
            {
              path: 'Axle.DefectClassMarking',
              name: 'Axle.DefectClassMarkingWagon',
              type: 'option',
              option: 'ListingAxleDefectClass',
              showTranslatedText: true,
            },
            {
              path: 'Axle.UicDefectClass',
              type: 'option',
              option: 'ListingAxleUicDefectClass',
              showTranslatedText: true,
            },
          ],
        },
        axlePaintwork: {
          listPath: 'Axle.PaintworkCollection.Paintwork',
          minSize: 0,
          maxSize: 1,
          differentiator: 'Type',
          differentiatorName: 'Art',
          differentiatorOption: 'ListingPaintType',
          data: [
            {
              path: 'Type',
              name: 'differentiator.Art',
              type: 'option',
              option: 'ListingPaintType',
              showTranslatedText: true,
            },
            { path: 'PaintworkApplied', type: 'boolean' },
          ],
        },
        wheelMeasures: {
          listPath: 'WheelCollection.Wheel',
          differentiator: 'Side',
          differentiatorOption: 'ListingSide',
          data: [
            {
              path: 'FlangeThicknessE',
              type: 'double',
              invoke: 'calculateSRMass',
              unit: 'mm',
            },
            {
              path: 'FlangeHeightH',
              type: 'double',
              unit: 'mm',
            },
            {
              path: 'FlangeFaceQr',
              type: 'double',
              unit: 'mm',
            },
            {
              path: 'NominalTreadDiameterD',
              type: 'double',
              unit: 'mm',
            },
            {
              path: 'RadialDeviation',
              type: 'double',
              unit: 'mm',
            },
          ],
        },
        audits: {
          data: [
            {
              path: 'WorkshopLastIS3',
              type: 'option',
              option: 'ListingWorkshop',
              showTranslatedText: true,
            },
            {
              path: 'DateLastIS3',
              type: 'date',
            },
            {
              path: 'WorkshopLastIS2',
              type: 'option',
              option: 'ListingWorkshop',
              showTranslatedText: true,
            },
            {
              path: 'DateLastIS2',
              type: 'date',
            },
            {
              path: 'WorkshopLastIS1',
              type: 'option',
              option: 'ListingWorkshop',
              showTranslatedText: true,
            },
            {
              path: 'DateLastIS1',
              type: 'date',
            },
            {
              path: 'WorkshopLastIL',
              type: 'option',
              option: 'ListingWorkshop',
              showTranslatedText: true,
            },
            {
              path: 'DateLastIL',
              type: 'date',
            },
            {
              path: 'Condition',
              type: 'option',
              option: 'ListingWheelsetCondition',
              showTranslatedText: true,
            },
          ],
        },
        bearing: {
          listPath: 'BearingCollection.Bearing',
          differentiator: 'Position',
          differentiatorOption: 'ListingBearingPosition',
          uniformPaths: ['Type', 'CageMaterial'],
          completeUniform: true,
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingBearingPosition',
              showTranslatedText: true,
            },
            {
              path: 'Type',
              name: 'BearingType',
              type: 'option',
              option: 'ListingBearingType',
              showTranslatedText: true,
            },
            {
              path: 'CageMaterial',
              type: 'option',
              option: 'ListingBearingCageMaterial',
              showTranslatedText: true,
            },
          ],
        },
        bearingHousing: {
          listPath: 'BearingHousingCollection.BearingHousing',
          differentiator: 'Side',
          differentiatorOption: 'ListingSide',
          data: [
            {
              path: 'Side',
              type: 'option',
              name: 'side',
              option: 'ListingSide',
              showTranslatedText: true,
            },
            {
              path: 'Type',
              name: 'BearingHousingType',
              type: 'option',
              option: 'ListingBearingHousingType',
              showTranslatedText: true,
            },
            {
              path: 'GreaseType',
              type: 'option',
              option: 'ListingGreaseType',
              showTranslatedText: true,
            },
          ],
        },
      },
      differentiator: 'Position',
      differentiatorOption: 'ListingDetailedPosition',
      listPath: 'Chassis.WheelsetCollection.Wheelset',
    },
    superstructure: {
      listPath: 'SuperstructureCollection.Superstructure',
      differentiator: 'Position',
      differentiatorOption: 'ListingDetailedPosition',
      chapters: {
        basedata: {
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingDetailedPosition',
            },
            {
              path: 'SuperstructureType',
              type: 'option',
              option: 'customList',
              optionAdd: [
                'all',
                'tank',
                'staubgut',
                'schuettgut',
                'flatwagon',
                'autoTransporter',
                'box',
              ],
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
          ],
        },
        tank: {
          data: [
            {
              path: 'Tank.TankNumber',
              type: 'string',
            },
            {
              path: 'Tank.ApprovalNumber',
              type: 'string',
            },
            {
              path: 'Tank.Tankcode',
              type: 'option',
              option: 'ListingTankCodeMineralOilChemistry',
            },
            {
              path: 'Tank.Behaelterpruefdatum',
              type: 'monthAndYear',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'Tank.WorkshopLastAInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'Tank.DateLastAInspection',
              type: 'monthAndYear',
            },
            {
              path: 'Tank.WorkshopLastLInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'Tank.DateLastLInspection',
              type: 'monthAndYear',
            },
            {
              path: 'Tank.WorkshopLastPInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'Tank.DateLastPInspection',
              type: 'monthAndYear',
            },
            {
              path: 'Tank.WorkshopLastDInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'Tank.DateLastDInspection',
              type: 'monthAndYear',
            },
            {
              path: 'Tank.WorkshopLastKInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'Tank.DateLastKInspection',
              type: 'monthAndYear',
            },
            {
              path: 'Tank.FieldOfLaw',
              type: 'option',
              option: 'ListingFieldOfLaw',
            },
            {
              path: 'Tank.DateNextTankInspection',
              type: 'monthAndYear',
            },
            {
              path: 'Tank.NumberOfChambers',
              type: 'option',
              option: 'ListingNumberOfChambers',
            },
            {
              path: 'Tank.TypeOfNextTankInspection',
              type: 'option',
              option: 'ListingLastTankTestType',
            },
            {
              path: 'Tank.IsLining',
              type: 'boolean',
            },
            {
              path: 'Tank.YearOfManufacture',
              type: 'year',
            },
            {
              path: 'Tank.OperatingPressure',
              type: 'double',
              unit: 'MPa',
            },
            {
              path: 'Tank.Manufacturer',
              type: 'option',
              option: 'ListingManufacturer',
            },
            {
              path: 'Tank.ManufacturerSerialNumber',
              type: 'string',
            },
            {
              path: 'Tank.LastCircularWeldSeamInspection',
              type: 'date',
            },
            {
              path: 'Tank.LowestPermissibleFillingTemperature',
              type: 'double',
              unit: '°C',
            },
            {
              path: 'Tank.TestPressure',
              type: 'double',
              unit: 'MPa',
            },
            {
              path: 'Tank.TestingOrganisation',
              type: 'option',
              option: 'ListingTestingOrganisation',
            },
            {
              path: 'Tank.RIDRealVolume',
              type: 'double',
              unit: 'l',
            },
            {
              path: 'Tank.Volume',
              type: 'double',
              unit: 'l',
            },
            {
              path: 'Tank.UIPCleaningLevel',
              type: 'string',
            },
            {
              path: 'Tank.HeatInsulated',
              type: 'boolean',
            },
            {
              path: 'Tank.CentralWhiteStripe',
              type: 'boolean',
            },
            {
              path: 'Tank.Heating.OperatingPressure',
              type: 'double',
              unit: 'MPa',
            },
            {
              path: 'Tank.Heating.TestPressure',
              type: 'double',
              unit: 'MPa',
            },
            {
              path: 'Tank.Insulation.InsulationCoveringMaterialGroup',
              type: 'option',
              option: 'ListingMaterialGroup',
            },
          ],
        },
        staubgut: {
          data: [
            {
              path: 'PowderContainer.ConstructionYear',
              type: 'year',
            },
            {
              path: 'PowderContainer.DateLastContainerTest',
              type: 'monthAndYear',
            },
            {
              path: 'PowderContainer.PowderContainerNumber',
              type: 'string',
            },
            {
              path: 'Tank.ApprovalNumber',
              type: 'string',
            },
            {
              path: 'Tank.Tankcode',
              type: 'string',
              option: 'ListingTankCodeMineralOilChemistry',
            },
            {
              path: 'PowderContainer.Volume',
              type: 'double',
              unit: 'l',
            },
            {
              path: 'PowderContainer.MaximumOperatingPressure',
              type: 'double',
              unit: 'MPa',
            },
            {
              path: 'PowderContainer.TestingPressure',
              type: 'double',
              unit: 'MPa',
            },
            {
              path: 'PowderContainer.RealBoxCapacity',
              type: 'double',
              unit: 'l',
            },
            {
              path: 'PowderContainer.PurityLevel',
              type: 'option',
              option: 'ListingPowderContainerCleaningLevelKey',
            },
            {
              path: 'PowderContainer.WorkshopLastAInspection',
              name: 'Tank.WorkshopLastAInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'PowderContainer.DateLastAInspection',
              name: 'Tank.DateLastAInspection',
              type: 'monthAndYear',
            },
            {
              path: 'PowderContainer.WorkshopLastLInspection',
              name: 'Tank.WorkshopLastLInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'PowderContainer.DateLastLInspection',
              name: 'Tank.DateLastLInspection',
              type: 'monthAndYear',
            },
            {
              path: 'PowderContainer.WorkshopLastPInspection',
              name: 'Tank.WorkshopLastPInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'PowderContainer.DateLastPInspection',
              name: 'Tank.DateLastPInspection',
              type: 'monthAndYear',
            },
            {
              path: 'PowderContainer.WorkshopLastDInspection',
              name: 'Tank.WorkshopLastDInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'PowderContainer.DateLastDInspection',
              name: 'Tank.DateLastDInspection',
              type: 'monthAndYear',
            },
            {
              path: 'PowderContainer.WorkshopLastKInspection',
              name: 'Tank.WorkshopLastKInspection',
              type: 'option',
              option: 'ListingWorkshop',
            },
            {
              path: 'PowderContainer.DateLastKInspection',
              name: 'Tank.DateLastKInspection',
              type: 'monthAndYear',
            },
            {
              path: 'PowderContainer.FieldOfLaw',
              name: 'Tank.FieldOfLaw',
              type: 'option',
              option: 'ListingFieldOfLaw',
            },
            {
              path: 'PowderContainer.DateNextContainerInspection',
              type: 'monthAndYear',
            },
          ],
        },
        fluidisation: {
          listPath:
            'PowderMaterialEquipment.AerationSystemCollection.AerationSystem',
          differentiator: 'Position',
          differentiatorOption: 'ListingDetailedPosition',
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingDetailedPosition',
            },
            {
              path: 'Type',
              name: 'AuflockerungseinrichtungBauart',
              type: 'option',
              option: 'ListingAerationSystemType',
            },
            {
              path: 'Material',
              name: 'AuflockerungseinrichtungMaterial',
              type: 'option',
              option: 'ListingAerationSystemMaterial',
            },
          ],
        },
        schuettgut: {
          data: [
            {
              path: 'BulkContainer.NominalCapacity',
              type: 'double',
              unit: 'm3',
              unitDisplayed: 'm³',
            },
          ],
        },
        flatwagon: {
          data: [
            {
              path: 'SuperstructureFlatwagon.SingleCargoArea',
              type: 'double',
              unit: 'm²',
            },
            {
              path: 'SuperstructureFlatwagon.CargoArea',
              type: 'double',
              unit: 'm²',
            },
          ],
        },
        box: {
          data: [
            {
              path: 'Box.Area',
              type: 'double',
              unit: 'm²',
            },
            {
              path: 'Box.Volume',
              type: 'double',
              unit: 'l',
            },
          ],
        },
        autoTransporter: {
          data: [
            {
              path: 'CarCarrierWagonLowerLevel.MaxHeight',
              type: 'double',
              unit: 'm',
            },
            {
              path: 'CarCarrierWagonLowerLevel.MaxLoad',
              type: 'double',
              unit: 't',
            },
            {
              path: 'CarCarrierWagonLowerLevel.CarCarrierWagonUpperLevel.MaxLoad',
              type: 'double',
              unit: 't',
            },
          ],
        },
        equipmentFlachwagen: {
          data: [
            {
              path: 'FlatWagonEquipment.SemiTrailerSeatingDevice.Manufacturer',
              type: 'option',
              option: 'ListingManufacturer',
            },
            {
              path: 'FlatWagonEquipment.SemiTrailerSeatingDevice.ManufacturersDesignation',
              type: 'option',
              option: 'ListingSemiTrailerSeatingDeviceType',
            },
            {
              path: 'FlatWagonEquipment.SemiTrailerSeatingDevice.SerialNumber',
              type: 'string',
            },
            {
              path: 'FlatWagonEquipment.RotatingFrame.Manufacturer',
              type: 'option',
              option: 'ListingManufacturer',
            },
            {
              path: 'FlatWagonEquipment.ContainerPins.Type',
              type: 'option',
              option: 'ListingContainerLocatingPinsType',
            },
          ],
        },
        manhole: {
          data: [
            {
              //path actually expects a optionlist-value
              path: 'TankEquipment.ManholeCollection.Manhole[0].Type',
              name: 'BauartMannloch',
              type: 'option',
              option: 'ListingManholeType',
            },
          ],
        },
      },
    },
    drawAndBufferingGear: {
      chapters: {
        climbingProtection: {
          data: [
            {
              //path actually expects a optionlist-value
              path: 'Chassis.BufferAndDrawGear.ClimbingProtection.Manufacturer',
              name: 'AufkletterschutzVorhanden',
              type: 'boolean',
              option: 'ListingManufacturer',
            },
          ],
        },
        buffer: {
          listPath: 'Chassis.BufferAndDrawGear.BufferCollection.Buffer',
          differentiator: 'Position',
          differentiatorOption: 'ListingBufferPosition',
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingBufferPosition',
            },
            {
              path: 'Type',
              name: 'BufferBauartPuffer',
              type: 'option',
              option: 'ListingBufferManufacturer',
            },
            {
              path: 'LastRefurbishment',
              name: 'BufferLetzteAufarbeitung',
              type: 'date',
            },
            {
              onlyForCollectionKey: '1L',
              isAbsolutePath: true,
              path: 'Chassis.UnderframeCollection.Underframe[0].Z111L',
              name: 'Z111L',
              type: 'double',
              unit: 'mm',
            },
            {
              onlyForCollectionKey: '2L',
              isAbsolutePath: true,
              path: 'Chassis.UnderframeCollection.Underframe[0].Z112L',
              name: 'Z112L',
              type: 'double',
              unit: 'mm',
            },
            {
              onlyForCollectionKey: '1R',
              isAbsolutePath: true,
              path: 'Chassis.UnderframeCollection.Underframe[0].Z111R',
              name: 'Z111R',
              type: 'double',
              unit: 'mm',
            },
            {
              onlyForCollectionKey: '2R',
              isAbsolutePath: true,
              path: 'Chassis.UnderframeCollection.Underframe[0].Z112R',
              name: 'Z112R',
              type: 'double',
              unit: 'mm',
            },
          ],
        },
        couplingRod: {
          listPath:
            'Chassis.BufferAndDrawGear.CouplingRodCollection.CouplingRod',
          differentiator: 'Position',
          differentiatorOption: 'ListingDrawGearPosition',
          uniformPaths: ['Type', 'Manufacturer'],
          completeUniform: true,
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingDrawGearPosition',
            },
            {
              path: 'Type',
              name: 'BauartKuppelstange',
              type: 'string',
            },
            {
              path: 'Manufacturer',
              name: 'HerstellerKuppelstange',
              type: 'string',
            },
          ],
        },
        coupling: {
          listPath: 'Chassis.BufferAndDrawGear.CouplingCollection.Coupling',
          differentiator: 'Position',
          differentiatorOption: 'ListingDrawGearPosition',
          uniformPaths: ['Type', 'UltimateLoad'],
          completeUniform: true,
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingDrawGearPosition',
            },
            {
              path: 'Type',
              name: 'KupplungBauart',
              type: 'option',
              option: 'ListingCouplingTypeDesignation',
            },
            {
              path: 'UltimateLoad',
              name: 'KupplungBruchlast',
              type: 'option',
              option: 'ListingUltimateLoad',
              inputType: 'double',
              unit: 'KN',
              unitDisplayed: 'kN',
            },
          ],
        },
        drawHook: {
          listPath: 'Chassis.BufferAndDrawGear.DrawHookCollection.DrawHook',
          differentiator: 'Position',
          differentiatorOption: 'ListingDrawhookPosition',
          uniformPaths: ['Type', 'DrawbarHookLength', 'UltimateLoad'],
          completeUniform: true,
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingDrawhookPosition',
            },
            {
              path: 'Type',
              name: 'ZughakenBauart',
              type: 'option',
              option: 'ListingDrawhookType',
            },
            {
              path: 'DrawbarHookLength',
              type: 'option',
              option: 'ListingDrawhookLength',
              inputType: 'double',
              unit: 'mm',
            },
            {
              path: 'UltimateLoad',
              name: 'ZughakenBruchlast',
              type: 'option',
              option: 'ListingUltimateLoad',
              inputType: 'double',
              unit: 'KN',
              unitDisplayed: 'kN',
            },
          ],
        },
        drawGearUniform: {
          listPath: 'Chassis.BufferAndDrawGear.DrawGearCollection.DrawGear',
          differentiator: 'Position',
          differentiatorOption: 'ListingDrawGearPosition',
          uniformPaths: ['Type'],
          completeUniform: true,
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingDrawGearPosition',
            },
            {
              path: 'Type',
              name: 'ZugeinrichtungBauart',
              type: 'option',
              option: 'ListingDrawGearType',
            },
          ],
        },
        drawGearSingle: {
          listPath: 'Chassis.BufferAndDrawGear.DrawGearCollection.DrawGear',
          differentiator: 'Position',
          differentiatorOption: 'ListingDrawGearPosition',
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingDrawGearPosition',
            },
            {
              path: 'Type',
              name: 'ZugeinrichtungBauart',
              type: 'option',
              option: 'ListingDrawGearType',
            },
          ],
        },
      },
    },
    mobileService: {
      chapters: {
        basedata: {
          data: [
            {
              path: 'DeadlineExtension',
              type: 'boolean',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'PerformedMaintenanceSteps',
              type: 'textarea',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'DeferredWork',
              type: 'textarea',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'ChangedComponents',
              type: 'textarea',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'MaintenancePerformedCorrectly',
              type: 'boolean',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'maintenanceNotPossible',
              type: 'boolean',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'ReleaseToServiceGranted',
              type: 'boolean',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
            {
              path: 'IssuingDateCurrentReleaseToService',
              type: 'date',
              ioType: ioTypes.OUTGOING,
              activityType: 'ACTIVITY',
            },
          ],
        },
      },
    },
  },
  wheelset: {
    basedata: {
      data: [
        {
          path: 'WheelsetNumber',
          type: 'string',
        },
        {
          path: 'DismountedFromWagon',
          type: 'string',
          halfWidth: true,
          useSelfCheckNumber: true,
          ioType: ioTypes.INCOMING,
          activityType: 'ACTIVITY',
        },
        {
          path: 'MountedInWagon',
          type: 'string',
          halfWidth: true,
          useSelfCheckNumber: true,
          ioType: ioTypes.OUTGOING,
          activityType: 'ACTIVITY',
        },
        {
          path: 'DateMounted',
          type: 'date',
          halfWidth: true,
          ioType: ioTypes.OUTGOING,
          activityType: 'ACTIVITY',
        },
        {
          path: 'NameMounted',
          type: 'string',
          halfWidth: true,
          ioType: ioTypes.OUTGOING,
          activityType: 'ACTIVITY',
        },
        {
          path: 'StampedInstallationDate',
          type: 'date',
        },
        {
          path: 'WheelsetOwnersMark',
          type: 'option',
          option: 'ListingOwnersMark',
          showTranslatedText: true,
        },
        {
          path: 'MaintenanceDate',
          name: 'OverhaulDate',
          type: 'date',
        },
        {
          path: 'PerformedISMaintenanceLevel',
          type: 'option',
          option: 'ListingWheelsetPerformedMaintenanceLevel',
          showTranslatedText: true,
        },
        {
          path: 'RemovalReason',
          type: 'option',
          option: 'ListingReasonForWheelsetRemoval',
          showTranslatedText: true,
        },
        {
          path: 'Type',
          name: 'WheelsetType',
          type: 'option',
          option: 'ListingWheelsetType',
          showTranslatedText: true,
        },
        {
          path: 'GeneralBearingHousingType',
          type: 'option',
          option: 'ListingWheelsetBearingHousingType',
          showTranslatedText: true,
        },
        {
          path: 'FormerNationalRailway',
          type: 'option',
          option: 'ListingFormerNationalRailway',
          showTranslatedText: true,
        },
        {
          path: 'MaximumLoad',
          type: 'option',
          option: 'ListingMaximumWheelsetLoad',
          inputType: 'double',
          unit: 't',
        },
        {
          path: 'TsiApproval',
          name: 'TSIApproval',
          type: 'boolean',
        },
        {
          path: 'TSINumber',
          name: 'TSIZulassungsnummer',
          type: 'string',
        },
        {
          path: 'TSINoBo',
          name: 'TSIZulassungsstelle',
          type: 'option',
          option: 'ListingTSINotifiedBody',
          showTranslatedText: true,
        },
      ],
    },
    wheelBasedata: {
      listPath: 'WheelCollection.Wheel',
      differentiator: 'Side',
      differentiatorOption: 'ListingSide',
      fixedSet: true,
      data: [
        {
          path: 'Manufacturer',
          type: 'option',
          option: 'ListingManufacturer',
          showTranslatedText: true,
        },
        {
          path: 'YearOfManufacture',
          type: 'monthAndYear',
        },
        {
          path: 'LfNrderSchmelzeRad',
          type: 'string',
        },
        {
          path: 'CastingBatchNumber',
          type: 'string',
        },
        {
          path: 'MaterialQuality',
          type: 'option',
          option: 'ListingMaterial',
          showTranslatedText: true,
        },
        {
          path: 'Type',
          name: 'WheelType',
          type: 'option',
          option: 'ListingWheelType',
          showTranslatedText: true,
        },
        {
          path: 'PermittedWheelLoad',
          type: 'option',
          inputType: 'double',
          option: 'ListingMaximumWheelsetLoad',
          unit: 't',
          showTranslatedText: true,
        },
        {
          path: 'TSINoBo',
          name: 'TSIZulassungsstelle',
          type: 'option',
          option: 'ListingTSINotifiedBody',
          showTranslatedText: true,
        },
        {
          path: 'TSINumber',
          name: 'TSIZulassungsnummer',
          type: 'string',
        },
      ],
    },
    measures: {
      data: [
        {
          path: 'Ar1',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'Ar2',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'a1Dimension',
          type: 'double',
          invoke: 'calculateSRMass',
          unit: 'mm',
        },
        {
          path: 'a2Dimension',
          type: 'formula',
          formula: 'calculateSRMass',
          unit: 'mm',
          decimalPlaces: 3,
          params: {
            ar: { path: 'a1Dimension' },
            sdA: { path: 'WheelCollection.Wheel[0].FlangeThicknessE' },
            sdB: { path: 'WheelCollection.Wheel[1].FlangeThicknessE' },
          },
        },
        {
          path: 'CToC',
          type: 'double',
        },
        {
          path: 'numbersOfMeasuringEquip',
          type: 'textarea',
          ioType: ioTypes.OUTGOING,
          activityType: 'ACTIVITY',
        },
      ],
    },
    wheelMeasures: {
      listPath: 'WheelCollection.Wheel',
      differentiator: 'Side',
      differentiatorOption: 'ListingSide',
      fixedSet: true,
      data: [
        {
          path: 'FlangeThicknessE',
          type: 'double',
          invoke: 'calculateSRMass',
          unit: 'mm',
        },
        {
          path: 'FlangeHeightH',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'FlangeFaceQr',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'RimWidth',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'NominalTreadDiameterD',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'RadialDeviation',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'AxialDeviation',
          type: 'double',
          unit: 'mm',
        },
      ],
    },
    axleBasedata: {
      data: [
        {
          path: 'Axle.Type',
          type: 'option',
          option: 'ListingAxleType',
          showTranslatedText: true,
        },
        {
          path: 'Axle.AxleNumberOld',
          type: 'string',
        },
        {
          path: 'Axle.AxleManufacturer',
          type: 'option',
          option: 'ListingManufacturer',
          showTranslatedText: true,
        },
        {
          path: 'Axle.YearOfManufacture',
          type: 'year',
        },
        {
          path: 'Axle.AxleMaterial',
          type: 'option',
          option: 'ListingMaterial',
          showTranslatedText: true,
        },
        {
          path: 'Axle.OwnersMark',
          type: 'option',
          option: 'ListingOwnersMark',
          showTranslatedText: true,
        },
        {
          path: 'Axle.AxleBatchNumber',
          type: 'string',
        },
        {
          path: 'Axle.AxleLoadCapacity',
          type: 'option',
          option: 'ListingMaximumWheelsetLoad',
          unit: 't',
          inputType: 'double',
        },
        {
          path: 'Axle.DefectClassMarking',
          type: 'option',
          option: 'ListingAxleDefectClass',
          showTranslatedText: true,
        },
        {
          path: 'Axle.UicDefectClass',
          type: 'option',
          option: 'ListingAxleUicDefectClass',
          showTranslatedText: true,
        },
        {
          path: 'Axle.WheelsetNumberAxle',
          type: 'string',
        },
        {
          path: 'Axle.AxleEndCap',
          type: 'option',
          option: 'ListingAxleEndCap',
        },
        {
          path: 'Axle.TSINumber',
          name: 'TSIZulassungsnummer',
          type: 'string',
        },
        {
          path: 'Axle.TSINoBo',
          name: 'TSIZulassungsstelle',
          type: 'option',
          option: 'ListingTSINotifiedBody',
        },
      ],
    },
    axleMeasures: {
      data: [
        {
          path: 'Axle.JournalRadialDeviationA',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'Axle.JournalRadialDeviationB',
          type: 'double',
          unit: 'mm',
        },
        {
          path: 'Axle.AxleJournalExternalDiameterA',
          type: 'double',
          invoke: 'calculateShrinkInterferenceFit',
          unit: 'mm',
        },
        {
          path: 'Axle.AxleJournalInternalDiameterA',
          type: 'double',
          invoke: 'calculateShrinkInterferenceFit',
          unit: 'mm',
        },
        {
          path: 'Axle.AxleJournalInternalDiameterB',
          type: 'double',
          invoke: 'calculateShrinkInterferenceFit',
          unit: 'mm',
        },
        {
          path: 'Axle.AxleJournalExternalDiameterB',
          type: 'double',
          invoke: 'calculateShrinkInterferenceFit',
          unit: 'mm',
        },
        {
          path: 'Axle.OuterDegreeOfShrinkageA',
          type: 'formula',
          formula: 'calculateShrinkInterferenceFit',
          unit: 'µm',
          params: {
            axleStubBore: { path: 'Axle.AxleJournalExternalDiameterA' },
            diameterRing: {
              path: 'InnerRingDiameter',
              collectionIdentifier: ['Front A', 'Vorne A', 'Innen A'],
              referencePath: 'wheelset.bearing.chapters.bearing',
            },
          },
        },
        {
          path: 'Axle.InnerDegreeOfShrinkageA',
          type: 'formula',
          formula: 'calculateShrinkInterferenceFit',
          unit: 'µm',
          params: {
            axleStubBore: { path: 'Axle.AxleJournalInternalDiameterA' },
            diameterRing: {
              path: 'InnerRingDiameter',
              collectionIdentifier: ['Rear A', 'Hinten A', 'Außen A'],
              referencePath: 'wheelset.bearing.chapters.bearing',
            },
          },
        },
        {
          path: 'Axle.InnerDegreeOfShrinkageB',
          type: 'formula',
          formula: 'calculateShrinkInterferenceFit',
          unit: 'µm',
          params: {
            axleStubBore: { path: 'Axle.AxleJournalInternalDiameterB' },
            diameterRing: {
              path: 'InnerRingDiameter',
              collectionIdentifier: ['Front B', 'Vorne B', 'Innen B'],
              referencePath: 'wheelset.bearing.chapters.bearing',
            },
          },
        },
        {
          path: 'Axle.OuterDegreeOfShrinkageB',
          type: 'formula',
          formula: 'calculateShrinkInterferenceFit',
          unit: 'µm',
          params: {
            axleStubBore: { path: 'Axle.AxleJournalExternalDiameterB' },
            diameterRing: {
              path: 'InnerRingDiameter',
              collectionIdentifier: ['Rear B', 'Hinten B', 'Außen B'],
              referencePath: 'wheelset.bearing.chapters.bearing',
            },
          },
        },
        {
          path: 'Axle.ConcentricityDeviation',
          type: 'double',
          invoke: 'calculateShrinkInterferenceFit',
          unit: 'mm',
        },
        {
          path: 'Axle.FrictionRing.Width',
          type: 'double',
          unit: 'mm',
        },
      ],
    },
    bearing: {
      chapters: {
        bearing: {
          listPath: 'BearingCollection.Bearing',
          differentiator: 'Position',
          differentiatorOption: 'ListingBearingPosition',
          uniformPaths: ['Type', 'CageMaterial'],
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingBearingPosition',
              showTranslatedText: true,
            },
            {
              path: 'InnerRingDiameter',
              type: 'double',
              invoke: 'calculateShrinkInterferenceFit',
              unit: 'mm',
            },
            {
              path: 'BearingManufacturer',
              type: 'option',
              option: 'ListingManufacturerBearing',
              optionType: 'ListingManufacturer',
              showTranslatedText: true,
            },
            {
              path: 'YearOfManufactureBearing',
              type: 'year',
            },
            {
              path: 'RetrofittingWorkshop',
              type: 'option',
              option: 'ListingBearingRefurbishmentWorkshop',
              showTranslatedText: true,
            },
            {
              path: 'RetrofittingDate',
              type: 'date',
            },
            {
              path: 'InnerRingManufacturer',
              type: 'option',
              option: 'ListingManufacturer',
              showTranslatedText: true,
            },
            {
              path: 'YearOfManufactureInnerRing',
              type: 'year',
            },
            {
              path: 'Type',
              name: 'BearingType',
              type: 'option',
              option: 'ListingBearingType',
              showTranslatedText: true,
            },
            {
              path: 'CageMaterial',
              type: 'option',
              option: 'ListingBearingCageMaterial',
              showTranslatedText: true,
            },
          ],
        },
        bearingHousing: {
          listPath: 'BearingHousingCollection.BearingHousing',
          differentiator: 'Side',
          differentiatorOption: 'ListingSide',
          uniformPaths: ['Type'],
          completeUniform: true,
          data: [
            {
              path: 'Side',
              type: 'option',
              name: 'side',
              option: 'ListingSide',
              showTranslatedText: true,
            },
            {
              path: 'Type',
              name: 'BearingHousingType',
              type: 'option',
              option: 'ListingBearingHousingType',
              showTranslatedText: true,
            },
          ],
        },
      },
    },
    repairs: {
      chapters: {
        basedata: {
          data: [
            {
              path: 'ManufacturingStandard',
              type: 'option',
              option: 'ListingMaintenanceProgramme',
              optionAdd: ['VPI-EMG'],
            },
          ],
        },
        axle: {
          data: [
            {
              path: 'Axle.MarkingExecutedNDTA',
              type: 'boolean',
            },
            {
              path: 'Axle.MTReliefNotchNDTEM',
              type: 'option',
              option: 'ListingTestResult',
              showTranslatedText: true,
            },
            {
              path: 'Axle.MTReliefTroughStamp',
              type: 'year',
            },
            {
              path: 'Axle.MTAxleShaftNDTF',
              type: 'option',
              option: 'ListingTestResult',
              showTranslatedText: true,
            },
            {
              path: 'Axle.MTAxleJournalANTDS',
              type: 'option',
              option: 'ListingTestResult',
              showTranslatedText: true,
            },
            {
              path: 'Axle.MTAxleJournalBNTDS',
              type: 'option',
              option: 'ListingTestResult',
              showTranslatedText: true,
            },
            {
              path: 'Axle.MTInspectionType',
              type: 'option',
              option: 'ListingMTInspectionType',
              showTranslatedText: true,
            },
            {
              path: 'Axle.DefectClassMarking',
              type: 'option',
              option: 'ListingAxleDefectClass',
              showTranslatedText: true,
            },
            {
              path: 'Axle.UicDefectClass',
              type: 'option',
              option: 'ListingAxleUicDefectClass',
              showTranslatedText: true,
            },
            {
              path: 'Axle.HasZfPS',
              type: 'boolean',
            },
            {
              path: 'Axle.UltraSonicTest',
              type: 'option',
              option: 'ListingTestResult',
              showTranslatedText: true,
            },
          ],
        },
        paintwork: {
          listPath: 'Axle.PaintworkCollection.Paintwork',
          minSize: 0,
          maxSize: 1,
          differentiator: 'Type',
          differentiatorName: 'Art',
          differentiatorOption: 'ListingPaintType',
          data: [
            {
              path: 'Type',
              name: 'differentiator.Art',
              type: 'option',
              option: 'ListingPaintType',
              showTranslatedText: true,
            },
            {
              path: 'PaintworkApplied',
              type: 'boolean',
            },
            {
              path: 'ManufacturersDesignation',
              type: 'option',
              option: 'ListingPaintManufacturerDesignation',
              showTranslatedText: true,
            },
            {
              path: 'Colour',
              type: 'option',
              option: 'ListingPaintColour',
              showTranslatedText: true,
            },
          ],
        },
        wheel: {
          listPath: 'WheelCollection.Wheel',
          differentiator: 'Side',
          differentiatorOption: 'ListingSide',
          uniformPaths: [
            'UTWheelRimNDTB',
            'ProfileTurned',
            'ProfileDesignation',
          ],
          fixedSet: true,
          data: [
            {
              path: 'UTWheelRimNDTB',
              type: 'option',
              option: 'ListingTestResult',
              showTranslatedText: true,
            },
            {
              path: 'MTClampingNotch',
              type: 'option',
              option: 'ListingTestResult',
              showTranslatedText: true,
            },
            {
              path: 'UTInternalStressNDTD',
              type: 'double',
              negateable: true,
              unit: 'MPa',
            },
            {
              path: 'MTWheelNDTE',
              type: 'option',
              option: 'ListingTestResult',
              showTranslatedText: true,
            },
            {
              path: 'ProfileTurned',
              type: 'boolean',
            },
            {
              path: 'ProfileDesignation',
              type: 'option',
              option: 'ListingWheelProfileDesignation',
              showTranslatedText: true,
            },
          ],
        },
        bearing: {
          listPath: 'BearingCollection.Bearing',
          differentiator: 'Position',
          differentiatorOption: 'ListingBearingPosition',
          uniformPaths: [
            'InspectionPerformed',
            'InstallationPerformed',
            'GreaseBatchNumber',
            'GreaseManufacturingDate',
          ],
          completeUniform: true,
          data: [
            {
              path: 'Position',
              type: 'option',
              option: 'ListingBearingPosition',
              showTranslatedText: true,
            },
            {
              path: 'InspectionPerformed',
              type: 'boolean',
            },
            {
              path: 'InstallationPerformed',
              type: 'boolean',
            },
            {
              path: 'GreaseBatchNumber',
              type: 'string',
            },
            {
              path: 'GreaseManufacturingDate',
              type: 'date',
            },
          ],
        },
        bearingHousing: {
          listPath: 'BearingHousingCollection.BearingHousing',
          differentiator: 'Side',
          differentiatorOption: 'ListingSide',
          uniformPaths: ['GreaseType'],
          completeUniform: true,
          data: [
            {
              path: 'Side',
              type: 'option',
              name: 'side',
              option: 'ListingSide',
              showTranslatedText: true,
            },
            {
              path: 'GreaseType',
              type: 'option',
              option: 'ListingGreaseType',
              showTranslatedText: true,
            },
          ],
        },
      },
    },
    audits: {
      data: [
        {
          path: 'WorkshopOfFirstInstallation',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateFirstInstallation',
          type: 'date',
        },
        {
          path: 'WorkshopLastIS3',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLastIS3',
          type: 'date',
        },
        {
          path: 'WorkshopLastIS2',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLastIS2',
          type: 'date',
        },
        {
          path: 'WorkshopLastIS1',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLastIS1',
          type: 'date',
        },
        {
          path: 'WorkshopLastD',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLastD',
          type: 'date',
        },
        {
          path: 'WorkshopLastIL',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLastIL',
          type: 'date',
        },
        {
          path: 'WorkshopLast3L',
          type: 'option',
          option: 'ListingWorkshop',
          showTranslatedText: true,
        },
        {
          path: 'DateLast3L',
          type: 'date',
        },
        {
          path: 'Condition',
          type: 'option',
          option: 'ListingWheelsetCondition',
          showTranslatedText: true,
        },
      ],
    },
  },
};
export default values;
